import { NewCompanyHolidayForm } from "./_components/new-company-holiday-form";

const NewCompanyHolidayListPage = () => {
  return (
    <div className="p-5 max-h-[calc(100%-56px)] overflow-y-auto">
      <NewCompanyHolidayForm />
    </div>
  );
};

export default NewCompanyHolidayListPage;
